import { render, staticRenderFns } from "./wisdomRecordbroad.vue?vue&type=template&id=a93a9754&scoped=true"
import script from "./wisdomRecordbroad.vue?vue&type=script&lang=js"
export * from "./wisdomRecordbroad.vue?vue&type=script&lang=js"
import style0 from "./wisdomRecordbroad.vue?vue&type=style&index=0&id=a93a9754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93a9754",
  null
  
)

export default component.exports